import { render, staticRenderFns } from "./AiParams.vue?vue&type=template&id=dbfed36c&"
import script from "./AiParams.vue?vue&type=script&lang=ts&"
export * from "./AiParams.vue?vue&type=script&lang=ts&"
import style0 from "./AiParams.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports